'use client'
import { useSearchParams } from 'next/navigation'
import Banner from '.'

export const ReferralBanner = () => {
  const searchParams = useSearchParams()
  const query = Object.fromEntries(searchParams?.entries() ?? [])
  const { referralBonus } = query

  if (!referralBonus) return null

  return (
    <Banner
      value={`This trial is eligible for a $100 enrollment bonus. Contact the trial to learn more.`}
    />
  )
}
